/* Won't Miss Garage wheel order v0.1.0
   Fills the order form from a product JSON (/products/<handle>.js) and the saved spec, works out totals,
   collects payment in a popup, posts the row to the Google Sheet, then lets the Shopify contact form post
   as the email backup. If the Shopify post fails after a successful payment, the payment is remembered in
   sessionStorage and reused, so nobody is charged twice. */
(function () {
  'use strict';
  var WMG = window.WMG = window.WMG || {};
  var root = document.querySelector('[data-wmg-order]');
  if (!root) return;
  var form = root.querySelector('form');
  var cfg = WMG.config || {};
  var payCfg = cfg.pay || {};
  var PAID_KEY = 'wmg_wheel_paid';

  var product = null;
  var spec = null;
  var busy = false;

  var el = {
    media: root.querySelector('[data-wmg-order-media]'),
    title: root.querySelector('[data-wmg-order-title]'),
    unit: root.querySelector('[data-wmg-order-unit]'),
    options: root.querySelector('[data-wmg-order-options]'),
    sumUnit: root.querySelector('[data-wmg-sum-unit]'),
    sumQty: root.querySelector('[data-wmg-sum-qty]'),
    sumTotal: root.querySelector('[data-wmg-sum-total]'),
    sumPay: root.querySelector('[data-wmg-sum-pay]'),
    sumPayLabel: root.querySelector('[data-wmg-sum-pay-label]'),
    sumPayRow: root.querySelector('[data-wmg-sum-pay-row]'),
    error: root.querySelector('[data-wmg-order-error]'),
    submit: root.querySelector('[data-wmg-order-submit]'),
    submitLabel: root.querySelector('[data-wmg-order-submit-label]'),
    close: root.querySelector('[data-wmg-order-close]')
  };

  function hidden(name) { return form ? form.querySelector('[data-hidden="' + name + '"]') : null; }
  function setHidden(name, value) { var h = hidden(name); if (h) h.value = value == null ? '' : String(value); }
  function specField(name) { return form ? form.querySelector('[data-spec="' + name + '"]') : null; }
  function qty() { var q = specField('qty'); var n = parseInt(q ? q.value : '', 10); return isNaN(n) || n < 1 ? 1 : n; }
  function showError(msg) { if (el.error) { el.error.textContent = msg; el.error.hidden = !msg; } }
  function setBusy(state, label) {
    busy = state;
    if (el.submit) el.submit.classList.toggle('is-busy', state);
    if (el.submitLabel && label) el.submitLabel.textContent = label;
  }

  /* ---------- product and variant ---------- */
  function currentVariant() {
    if (!product) return null;
    var selects = Array.prototype.slice.call(el.options.querySelectorAll('select[data-wmg-opt]'));
    if (!selects.length) return product.variants[0] || null;
    var chosen = selects.map(function (s) { return s.value; });
    var match = product.variants.filter(function (v) {
      return chosen.every(function (val, i) { return v.options[i] === val; });
    })[0];
    return match || product.variants[0] || null;
  }

  function renderOptions() {
    el.options.innerHTML = '';
    if (!product || !product.options) return;
    product.options.forEach(function (opt, i) {
      var values = opt.values || [];
      if (values.length === 1 && /default title/i.test(values[0])) return;
      var wrap = document.createElement('div');
      wrap.className = 'wmg-field';
      var id = 'WMGOrderOpt' + i;
      wrap.innerHTML = '<label for="' + id + '">' + WMG.esc(opt.name) + '</label>' +
        '<select id="' + id + '" name="contact[Option: ' + WMG.esc(opt.name) + ']" data-wmg-opt="' + i + '">' +
        values.map(function (v) { return '<option value="' + WMG.esc(v) + '">' + WMG.esc(v) + '</option>'; }).join('') +
        '</select>';
      el.options.appendChild(wrap);
    });
    Array.prototype.forEach.call(el.options.querySelectorAll('select'), function (s) { s.addEventListener('change', totals); });
  }

  function renderMedia() {
    if (!el.media) return;
    el.media.innerHTML = '';
    var video = (product.media || []).filter(function (m) { return m.media_type === 'video' && m.sources && m.sources.length; })[0];
    if (video) {
      var src = video.sources.filter(function (s) { return s.format === 'mp4'; }).sort(function (a, b) { return a.width - b.width; })[0] || video.sources[0];
      var v = document.createElement('video');
      v.setAttribute('data-wmg-autoplay', ''); v.muted = true; v.loop = true; v.playsInline = true; v.preload = 'metadata';
      if (video.preview_image && video.preview_image.src) v.poster = video.preview_image.src;
      var s = document.createElement('source'); s.src = src.url; s.type = src.mime_type || 'video/mp4'; v.appendChild(s);
      el.media.appendChild(v);
      if (WMG.media && WMG.media.refresh) WMG.media.refresh(el.media);
      return;
    }
    var img = product.featured_image || (product.images && product.images[0]);
    if (img) { var i = document.createElement('img'); i.src = img; i.alt = product.title || ''; i.loading = 'lazy'; el.media.appendChild(i); }
  }

  /* ---------- totals ---------- */
  function payAmount(total) {
    var mode = payCfg.wheelMode || 'full';
    var value = Number(payCfg.wheelDepositValue) || 0;
    if (payCfg.provider === 'none') return 0;
    if (mode === 'deposit_fixed') return Math.min(value, total);
    if (mode === 'deposit_percent') return Math.round(total * value) / 100;
    return total;
  }

  function totals() {
    var v = currentVariant();
    var unitCents = v ? v.price : (product ? product.price : 0);
    var q = qty();
    var totalCents = unitCents * q;
    var due = payAmount(totalCents / 100);
    if (el.unit) el.unit.textContent = WMG.money(unitCents);
    if (el.sumUnit) el.sumUnit.textContent = WMG.money(unitCents);
    if (el.sumQty) el.sumQty.textContent = String(q);
    if (el.sumTotal) el.sumTotal.textContent = WMG.money(totalCents);
    if (el.sumPay) el.sumPay.textContent = WMG.money(Math.round(due * 100));
    if (el.sumPayLabel) el.sumPayLabel.textContent = (payCfg.wheelMode || 'full') === 'full' ? 'Due now' : 'Deposit due now';
    if (el.sumPayRow) el.sumPayRow.hidden = payCfg.provider === 'none';
    setHidden('wheel', product ? product.title : '');
    setHidden('handle', product ? product.handle : '');
    setHidden('variant', v ? v.title : '');
    setHidden('variant_id', v ? v.id : '');
    setHidden('unit', (unitCents / 100).toFixed(2));
    setHidden('total', (totalCents / 100).toFixed(2));
    return { unit: unitCents / 100, total: totalCents / 100, due: due, variant: v, qty: q };
  }

  /* ---------- open / close ---------- */
  function open(p, s) {
    product = p; spec = s || {};
    if (el.title) el.title.textContent = p.title || '';
    renderMedia();
    renderOptions();
    ['pcd', 'diameter', 'width', 'offset', 'bore', 'vehicle', 'qty', 'notes'].forEach(function (k) {
      var f = specField(k);
      if (f && spec[k] != null && spec[k] !== '') f.value = spec[k];
    });
    showError('');
    totals();
    root.hidden = false;
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    var stored = readPaid();
    if (stored && stored.handle === p.handle) showError('Payment ' + stored.id + ' was already received for this wheel. Submit again to file the order; you will not be charged twice.');
  }
  function close() {
    root.hidden = true;
    var grid = document.querySelector('[data-wmg-wheel-grid]');
    if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  if (el.close) el.close.addEventListener('click', close);
  var qtyField = specField('qty');
  if (qtyField) qtyField.addEventListener('input', totals);

  function readPaid() { try { return JSON.parse(sessionStorage.getItem(PAID_KEY) || 'null'); } catch (e) { return null; } }
  function writePaid(v) { try { v ? sessionStorage.setItem(PAID_KEY, JSON.stringify(v)) : sessionStorage.removeItem(PAID_KEY); } catch (e) {} }

  /* ---------- submit ---------- */
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      if (!product) { showError('Pick a wheel from the grid first.'); return; }
      if (!form.reportValidity()) return;
      showError('');
      var t = totals();
      var label = el.submitLabel ? el.submitLabel.textContent : '';
      setBusy(true, 'Opening payment');

      var stored = readPaid();
      var payment;
      if (stored && stored.handle === product.handle) {
        payment = Promise.resolve(stored);
      } else {
        /* Called synchronously in the submit handler so the popup opens inside the user gesture. */
        payment = window.WMGPay.start({
          amount: t.due,
          currency: cfg.currency || 'USD',
          description: (product.title || 'Wheel order') + ' x' + t.qty + (t.variant && t.variant.title !== 'Default Title' ? ' (' + t.variant.title + ')' : '')
        }).then(function (res) { res.handle = product.handle; res.amount = t.due; writePaid(res); return res; });
      }

      payment.then(function (res) {
        setHidden('pay_provider', res.provider);
        setHidden('pay_id', res.id);
        setHidden('pay_status', res.status);
        setHidden('paid', (res.status === 'NOT_COLLECTED' ? 0 : (res.amount != null ? res.amount : t.due)).toFixed(2));
        setBusy(true, 'Filing order');
        var payload = WMG.formData(form);
        payload.type = 'wheel_order';
        payload.tab = root.getAttribute('data-tab') || 'Wheel Orders';
        payload['Payment payer'] = res.payer || '';
        payload['Spec saved at'] = spec && spec.saved_at ? spec.saved_at : '';
        return window.WMGSheets.send(payload);
      }).then(function (status) {
        setHidden('sheet_status', status);
        /* Native submit: Shopify posts the contact form and reloads the page with form.posted_successfully? */
        HTMLFormElement.prototype.submit.call(form);
      }).catch(function (err) {
        setBusy(false, label);
        showError(err && err.message ? err.message : 'Payment did not go through. Nothing was filed.');
      });
    });
  }

  /* ---------- after a successful post ---------- */
  if (document.documentElement.classList.contains('wmg-order-posted')) {
    root.hidden = false;
    writePaid(null);
    if (WMG.wheelSpec) WMG.wheelSpec.clear();
    root.scrollIntoView({ block: 'start' });
  }

  WMG.order = { open: open, close: close };
})();
